<template>
    <div class="qrcode">
        <div>
            <div class="common-table-title">
                <span class="tit">
                    数据列表
                </span>
                <el-button
                    type="primary"
                    @click="openDialog(null)"
                    round>
                    添加二维码
                </el-button>
            </div>
            <el-table
                class="table common-shadow"
                :data="tableData"
                v-loading="loading">
                <el-table-column
                    prop="uri"
                    type="index"
                    label="ID"
                    min-width="150" />
                <el-table-column
                    prop="name"
                    label="名称"
                    min-width="130" />
                <el-table-column
                    prop="nickname"
                    label="二维码"
                    min-width="120">
                    <template slot-scope="scope">
                        <el-button
                            type="primary"
                            size="mini"
                            @click="showQrcode(scope.row.url)"
                            plain>
                            查看二维码
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="scene_type"
                    label="场景类型"
                    min-width="120">
                    <template slot-scope="scope">
                        {{ scene_type[scope.row.scene_type] }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="enabled"
                    label="是否启用"
                    min-width="100">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.enabled"
                            @change="onEnabledChange(scope.row.uri)" />
                    </template>
                </el-table-column>
                <el-table-column
                    prop="scene"
                    label="场景标识"
                    min-width="120">
                    <template slot-scope="scope">
                        {{ scene[scope.row.scene] }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="time"
                    label="更新时间"
                    min-width="140">
                    <template slot-scope="scope">
                        {{ dateFormat(scope.row.time) }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    min-width="100">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="openDialog(scope.row)">
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            @click="del(scope.row.uri)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="common-table-pagination">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="searchParams.page"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="dataTotal" />
            </div>
        </div>
        <el-dialog
            class="dialog"
            width="50%"
            top="20vh"
            title="属性"
            :visible.sync="dialogVisible"
            @close="onDialogClose"
            :before-close="done => !isSubmiting && done()">
            <el-form
                class="form"
                ref="form"
                :model="formData"
                :rules="formRules"
                label-position="left"
                label-width="96px">
                <el-form-item
                    prop="name"
                    label="名称">
                    <el-input
                        v-model="formData.name"
                        placeholder="请输入名称"
                        :maxlength="10" />
                </el-form-item>
                <el-form-item
                    prop="scene_type"
                    label="场景类型">
                    <el-select v-model="formData.scene_type">
                        <el-option
                            v-for="(item, index) in scene_type"
                            :key="index"
                            :value="index"
                            :label="item" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    v-if="formData.scene_type === 0"
                    prop="expire_seconds"
                    label="有效期（秒）">
                    <el-input-number
                        class="input-number"
                        v-model="formData.expire_seconds"
                        controls-position="right"
                        :min="0"
                        :max="MonthSeconds"
                        :precision="0" />
                </el-form-item>
                <el-form-item
                    prop="open"
                    label="是否启用">
                    <el-switch v-model="formData.enabled" />
                </el-form-item>
                <el-form-item
                    prop="scene"
                    label="场景标识">
                    <el-select v-model="formData.scene">
                        <el-option
                            v-for="(val, key) in scene"
                            :key="key"
                            :value="key"
                            :label="val" />
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button
                    type="info"
                    round
                    :disabled="isSubmiting"
                    @click="dialogVisible = false">
                    取 消
                </el-button>
                <el-button
                    type="primary"
                    round
                    :loading="isSubmiting"
                    @click="submit">
                    确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getQrcodeList, addQrcode, editQrcode, delQrcode, enableQrcode } from '../../../api';
import { dateFormat } from '../../../utils/util';
import { openComfirm } from '../../../utils/common';

const MonthSeconds = 2592000; // 30天

export default {
    name: 'QrcodeList',
    props: {
        routerLevel: {
            type: Number,
            default: 2,
            required: true
        }
    },
    data () {
        return {
            MonthSeconds,
            loading: true,
            tableData: [],
            searchParams: {
                page: 1
            },
            scene_type: [],
            currentId: null,
            pageSize: 0,
            dataTotal: 0,
            formData: {
                uri: undefined,
                name: '',
                scene_type: 0,
                scene: '1',
                enabled: true,
                expire_seconds: MonthSeconds
            },
            formRules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ]
            },
            dialogVisible: false,
            isSubmiting: false,
            scene: Object.create(null)
        };
    },
    created () {
        this.getData();
    },
    methods: {
        async getData (page) {
            try {
                this.loading = true;
                if (page && typeof page === 'number') {
                    this.searchParams.page = page;
                } else {
                    this.searchParams.page = 1;
                }
                const res = await getQrcodeList(this.searchParams);
                this.loading = false;
                if (res) {
                    const { data, meta, scene_type, scene } = res;
                    this.tableData = data;
                    if (scene_type) this.scene_type = scene_type;
                    if (scene) this.scene = scene;
                    if (meta) {
                        this.dataTotal = meta.total;
                        this.pageSize = meta.per_page;
                    }
                }
            } catch (err) {
                console.error(err);
                this.loading = false;
            }

        },
        showQrcode (url) {
            const aDom = document.createElement('a');
            aDom.target = '_blacnk';
            aDom.href = url;
            aDom.click();
        },
        openDialog (data) {
            const { formData } = this;
            if (data) {
                const { uri, name, scene_type, scene, enabled, expire_seconds } = data;
                formData.uri = uri;
                formData.name = name;
                formData.scene_type = scene_type;
                formData.scene = scene;
                formData.enabled = enabled;
                formData.expire_seconds = expire_seconds;
            } else {
                formData.uri = undefined;
                formData.expire_seconds = MonthSeconds;
                formData.enabled = true;
            }
            this.dialogVisible = true;
        },
        onDialogClose () {
            this.$refs.form.resetFields();
        },
        submit () {
            if (this.isSubmiting) return;
            this.$refs.form.validate(async valid => {
                try {
                    if (valid) {
                        const { formData } = this;
                        this.isSubmiting = true;
                        let tip = '编辑成功！';
                        if (formData.uri) {
                            await editQrcode(formData.uri, formData);
                            this.editAfter();
                        } else {
                            if (formData.scene_type === 1) formData.expire_seconds = undefined;
                            await addQrcode(formData);
                            this.getData(this.searchParams.page);
                            tip = '添加成功！';

                        }
                        this.$message.success(tip);
                        this.dialogVisible = false;
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    this.isSubmiting = false;
                }
            });
        },
        editAfter () {
            const { uri, name, scene_type, scene, enabled, expire_seconds } = this.formData;
            const data = this.tableData.find(c => c.uri === uri);
            if (data) {
                data.name = name;
                data.scene_type = scene_type;
                data.scene = scene;
                data.enabled = enabled;
                data.expire_seconds = expire_seconds;
            }
        },
        async del (id) {
            try {
                const apiFn = (id) => {
                    return () => {
                        return delQrcode(id);
                    };
                };
                await openComfirm({
                    title: '提示',
                    message: '您确定要删除吗？',
                    successTip: '删除成功!',
                    apiFn: apiFn(id)
                });
                const index = this.tableData.findIndex(c => c.uri === id);
                if (index !== -1) this.tableData.splice(index, 1);
            } catch (err) {
                console.error(err);
            }
        },
        async onEnabledChange (id) {
            try {
                await enableQrcode(id);
                this.$message.success('操作成功！');
            } catch (err) {
                console.error(err);
            }
        },
        handleCurrentChange (val) {
            this.getData(val);
        },
        dateFormat (time) {
            if (!time) return '';
            return dateFormat(new Date(time * 1000), 'yyyy/MM/dd hh:mm');
        }
    }
};
</script>

<style lang="scss" scoped>
    .qrcode {

        .dialog {

            /deep/ .el-form {

                .el-select, .input-number {
                    width: 100%;

                    input {
                        text-align: left;
                    }
                }
            }
        }
    }
</style>
